module.exports = __webpack_public_path__ + "20_vi.jpg?15343d369713148e8c1b56502eba8967";


//////////////////
// WEBPACK FOOTER
// ./src/assets/paperImg/20_vi.jpg
// module id = 175
// module chunks = 0